var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t代岗申请-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "组织架构",
      "prop": "spare5"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.ruleForm.spare5),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "spare5", $$v)
      },
      expression: "ruleForm.spare5"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.city_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "city_id", $$v)
      },
      expression: "ruleForm.city_id"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代岗人",
      "prop": "replace_staff_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.replace_staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "replace_staff_name", $$v)
      },
      expression: "ruleForm.replace_staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代岗原因",
      "prop": "replace_reason"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入代岗原因"
    },
    model: {
      value: (_vm.ruleForm.replace_reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "replace_reason", $$v)
      },
      expression: "ruleForm.replace_reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类别",
      "prop": "replace_type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.replace_type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "replace_type", $$v)
      },
      expression: "ruleForm.replace_type"
    }
  }, _vm._l((_vm.lbList), function(item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代岗开始时间",
      "prop": "start_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.ruleForm.start_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "start_date", $$v)
      },
      expression: "ruleForm.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代岗结束时间",
      "prop": "end_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.ruleForm.end_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "end_date", $$v)
      },
      expression: "ruleForm.end_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "天数",
      "prop": "replace_days"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入天数"
    },
    model: {
      value: (_vm.ruleForm.replace_days),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "replace_days", $$v)
      },
      expression: "ruleForm.replace_days"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "元/天",
      "prop": "day_price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入元/天"
    },
    model: {
      value: (_vm.ruleForm.day_price),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "day_price", $$v)
      },
      expression: "ruleForm.day_price"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "总金额",
      "prop": "total_amount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入总金额"
    },
    model: {
      value: (_vm.ruleForm.total_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "total_amount", $$v)
      },
      expression: "ruleForm.total_amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "22%"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.AddAuditor()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateAuditor()
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "代岗人",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "checkbox",
      "accordion": false,
      "staff_id_prop": _vm.object.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415f87e4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Dgsq/Dgsq_add.vue
// module id = null
// module chunks = 